export default "__VITE_ASSET__63028018__"